import { OutlineEightIcon } from '@components/icons/OutlineEightIcon'
import { OutlineFiveIcon } from '@components/icons/OutlineFiveIcon'
import { OutlineFourIcon } from '@components/icons/OutlineFourIcon'
import { OutLineMobileEightIcon } from '@components/icons/OutLineMobileEightIcon'
import { OutLineMobileFiveIcon } from '@components/icons/OutLineMobileFiveIcon'
import { OutLineMobileFourIcon } from '@components/icons/OutLineMobileFourIcon'
import { OutLineMobileNineIcon } from '@components/icons/OutLineMobileNineIcon'
import { OutLineMobileOneIcon } from '@components/icons/OutLineMobileOneIcon'
import { OutLineMobileSevenIcon } from '@components/icons/OutLineMobileSevenIcon'
import { OutLineMobileSixIcon } from '@components/icons/OutLineMobileSixIcon'
import { OutLineMobileTenIcon } from '@components/icons/OutLineMobileTenIcon'
import { OutLineMobileThreeIcon } from '@components/icons/OutLineMobileThreeIcon'
import { OutLineMobileTwoIcon } from '@components/icons/OutLineMobileTwoIcon'
import { OutlineNineIcon } from '@components/icons/OutlineNineIcon'
import { OutlineOneIcon } from '@components/icons/OutlineOneIcon'
import { OutlineSevenIcon } from '@components/icons/OutlineSevenIcon'
import { OutlineSixIcon } from '@components/icons/OutlineSixIcon'
import { OutlineTenIcon } from '@components/icons/OutlineTenIcon'
import { OutlineThreeIcon } from '@components/icons/OutlineThreeIcon'
import { OutlineTwoIcon } from '@components/icons/OutlineTwoIcon'

export const chartNumbers = [
  <>
    <OutlineOneIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileOneIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
  <>
    <OutlineTwoIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileTwoIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
  <>
    <OutlineThreeIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileThreeIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
  <>
    <OutlineFourIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileFourIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
  <>
    <OutlineFiveIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileFiveIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
  <>
    <OutlineSixIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileSixIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
  <>
    <OutlineSevenIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileSevenIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
  <>
    <OutlineEightIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileEightIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
  <>
    <OutlineNineIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileNineIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
  <>
    <OutlineTenIcon
      width='100'
      height='152'
      className='text-primary tablet-mobile:hidden'
    />
    <OutLineMobileTenIcon
      width='72'
      height='109'
      className='desktop:hidden text-primary'
    />
  </>,
]
